export const ColorToNumberDict = { "white":0, "black":1, "#fff700":2, 
							"limegreen": 3, "crimson":4, "dodgerblue":5, 
							"violet": 6, "darkorange":7 }
							
export const NumberToColorDict = { 0:"white", 1:"black", 2:"#fff700", 
							3:"limegreen", 4:"crimson", 5:"dodgerblue", 
							6:"violet", 7:"darkorange" }
export const ColorToStandardNames = { "white":"White", "black":"Black", "#fff700":"Yellow", 
							"limegreen": "Green", "crimson":"Red", "dodgerblue":"Blue", 
							"violet": "Purple", "darkorange":"Orange" }